import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70161578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comic" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cover" }, null, -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "section-intro" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "section-disable"
}
const _hoisted_10 = { class: "text-disable" }

import { computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useInfo, useAnniversary, useComic } from '@/store';
import { Status } from '@/types/enums';
import { formatTime } from '@/hooks/useTransformTime';
import { useBackgroundUrl } from './useComicImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'Comic',
  setup(__props) {

_useCssVars(_ctx => ({
  "79bd531a": (_unref(bgComic).mobile),
  "fb2ef818": (_unref(imgComicFrame).mobile),
  "6c2e001b": (_unref(comicCover).mobile),
  "d2aa5f36": (_unref(bgComicInfo).mobile),
  "6ca87aed": (_unref(btn).mobile),
  "56052bd8": (_unref(bgStatusDisable).mobile),
  "3f073778": (_unref(bgComic).pc),
  "23b07a45": (_unref(imgComicFrame).pc),
  "4a7021ec": (_unref(comicCover).pc),
  "58a4a736": (_unref(bgComicInfo).pc),
  "1646d57a": (_unref(imgComicTitle).pc),
  "02ecd5be": (_unref(btn).pc),
  "5cf697ae": (_unref(bgStatusDisable).pc)
}))

const {
  bgComic,
  bgComicInfo,
  bgStatusDisable,
  btn,
  imgComicFrame,
  imgComicTitle,
} = useBackgroundUrl();
const { comic } = storeToRefs(useAnniversary());
const { showComicReader } = storeToRefs(useComic());
const { getTrans } = useInfo();
const { getComic } = useComic();

watch(showComicReader, () => {
  window.scrollTo(0, 0);
});
const comicCover = computed(() => {
  return {
    pc: `url(${comic.value?.coverLandscape})` || '',
    mobile: `url(${comic.value?.coverPortrait})` || '',
  }
});
const textUnlock = computed(() => {
  return getTrans('IW_P2_COMIC_OPEN').replace('{time}', String(formatTime(comic.value?.unlockTime || 0)));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(getTrans)('IW_P2_COMIC').toUpperCase()), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", {
            class: "intro",
            innerHTML: _unref(comic)?.introduction
          }, null, 8, _hoisted_8)
        ]),
        (_unref(comic)?.status === _unref(Status).Open)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-read",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(getComic) && _unref(getComic)(...args)))
            }, _toDisplayString(_unref(getTrans)('IW_READ')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(textUnlock)), 1)
            ]))
      ])
    ])
  ]))
}
}

})